import { Notfi } from "../../../data/notifications";
import { PiStudentFill } from "react-icons/pi";
import { BiMoney, BiNotepad } from "react-icons/bi";
import { FaGraduationCap } from "react-icons/fa6";
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
const Teachers = () => {
    ChartJS.register(ArcElement, Tooltip, Legend)
    const data = {
        labels: ['Female Students 10,500', 'Male Students 24,500'],
        datasets: [
            {
                data: [30, 40,], // Data values for each segment
                backgroundColor: ['pink', 'blue'], // Colors for each segment
            },
        ],
    };
    return (
        <div className="bg-gray-100 text-gray-700">

            <div className="grid grid-col-1 md:grid-cols-2 mx-12 text-center pt-12">
                <div className="bg-white m-2 py-4  flex flex-col">
                    <span className="bg-purple-200 mx-auto md:p-4 p-2 rounded-full">
                        <PiStudentFill className="text-4xl text-purple-600" />
                    </span>

                    <h2>Total Students</h2>
                    <h2>3500</h2>
                </div>

                <div className="bg-white m-2 py-4  flex flex-col">
                    <span className="bg-blue-200 mx-auto md:p-4  p-2 rounded-full">
                        <BiNotepad className="text-4xl m-2 text-blue-600" />
                    </span>
                    <h2>Total Exams</h2>
                    <h2>19050</h2>
                </div>

                <div className="bg-white m-2 py-4  flex flex-col">
                    <span className="bg-orange-200 mx-auto md:p-4 p-2 rounded-full">
                        <FaGraduationCap className="text-4xl text-orange-600" />
                    </span>
                    <h2>Graduate Studies</h2>
                    <h2>23890</h2>

                </div>

                <div className="bg-white m-2 py-4  flex flex-col">
                    <span className="bg-green-200 mx-auto  md:p-4 p-2 rounded-full">
                        <BiMoney className="text-4xl m-2 text-green-600" />
                    </span>
                    <h2>Total Income</h2>
                    <h2>2102050</h2>

                </div>
            </div>



            <div className="bg-white py-4 my-12">
                <h1 className="text-xl text-center font-bold py-4">Students</h1>
                {/* Chart */}

                <div className="flex justify-center mx-auto md:w-[400px] sm:w-[300px]">

                    <Doughnut data={data} />
                </div>
            </div>

            <div className="md:flex">
                <div>
                    <div className=" px-4 bg-white py-4 space-y-4 overflow-y-scroll max-h-[400px]">
                        <div className="flex justify-between pt-4 pb-2 place-items-center">
                            <h2 className="text-xl ">Notifications</h2>
                            <h2>...</h2>
                        </div>
                        {Notfi.map((item, index) => (
                            <div key={index} className='border-b-2 border-gray-300 space-y-2'>
                                <h3
                                    className="bg-blue-400 text-white text-sm rounded-3xl w-fit px-2 py-2">
                                    {item.date}</h3>
                                <p>
                                    {item.text}
                                </p>
                                <span className="flex space-x-2 text-sm">
                                    <h4 className="text-gray-700">{item.author}</h4>
                                    <h4 className="text-gray-500">/ {item.timeAgo}</h4></span>
                            </div>
                        ))}


                    </div>

                </div>




                <div>
                    <div className="px-2 bg-white md:mb-4  mt-8">
                        <span className="flex justify-between">
                            <h1 className="font-bold text-xl md:py-4 py-2 max-[760px]:pt-4 place-items-center">My Students</h1>
                            <h1>...</h1>
                        </span>
                        <div className="md:flex md:justify-between">
                            <form className="md:flex-1 flex flex-col md:flex-row space-y-2 px-6 md:justify-between">
                                <input type="text" placeholder="Search by roll"
                                    className="md:py-0 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                                <input type="text" placeholder='Search by Name'
                                    className="md:py-0 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                                <input type="text" placeholder="Search by Class"
                                    className="md:py-0 py-2 outline-none block bg-gray-200 md:px-2 px-2" />
                            </form>
                            <button className="bg-yellow-500 max-[760px]:mt-8   max-[760px]:w-full  text-white py-4 md:px-8 ">SEARCH</button>
                        </div>
                    </div>


                    {/* ROW */}

                    <div className="container  mx-auto overflow-x-scroll mt-10 mb-12">
                        <table className="table-auto  overflow-x-auto border-collapse border">
                            <thead>
                                <tr>
                                    <th className="border px-4 py-2">#</th>
                                    <th className="border px-4 py-2">Photo</th>
                                    <th className="border px-4 py-2">Name</th>
                                    <th className="border px-4 py-2">Gender</th>
                                    <th className="border px-4 py-2">Class</th>
                                    <th className="border px-4 py-2">Section</th>
                                    <th className="border px-4 py-2">Parents</th>
                                    <th className="border px-4 py-2">Address</th>
                                    <th className="border px-4 py-2">Date Of Birth</th>
                                    <th className="border px-4 py-2">Phone</th>
                                    <th className="border px-4 py-2">E-mail</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className="border px-4 py-2">#0021</td>
                                    <td className="border px-4 py-2"><img src="/assests/student3.png" alt="" /></td>
                                    <td className="border px-4 py-2">Mark Willy</td>
                                    <td className="border px-4 py-2">Male</td>
                                    <td className="border px-4 py-2">2</td>
                                    <td className="border px-4 py-2">A</td>
                                    <td className="border px-4 py-2">Jack Sparrow</td>
                                    <td className="border px-4 py-2">TA-107 New York</td>
                                    <td className="border px-4 py-2">02/05/2001</td>
                                    <td className="border px-4 py-2">+123 9988568</td>
                                    <td className="border px-4 py-2">kazifahim93@gmail.com</td>
                                </tr>

                                <tr>
                                    <td className="border px-4 py-2">#0021</td>
                                    <td className="border px-4 py-2"><img src="/assests/student2.png" alt="" /></td>
                                    <td className="border px-4 py-2">Mark Willy</td>
                                    <td className="border px-4 py-2">Male</td>
                                    <td className="border px-4 py-2">2</td>
                                    <td className="border px-4 py-2">A</td>
                                    <td className="border px-4 py-2">Jack Sparrow</td>
                                    <td className="border px-4 py-2">TA-107 New York</td>
                                    <td className="border px-4 py-2">02/05/2001</td>
                                    <td className="border px-4 py-2">+123 9988568</td>
                                    <td className="border px-4 py-2">kazifahim93@gmail.com</td>
                                </tr>

                                <tr>
                                    <td className="border px-4 py-2">#0021</td>
                                    <td className="border px-4 py-2"><img src="/assests/student1.png" alt="" /></td>
                                    <td className="border px-4 py-2">Mark Willy</td>
                                    <td className="border px-4 py-2">Male</td>
                                    <td className="border px-4 py-2">2</td>
                                    <td className="border px-4 py-2">A</td>
                                    <td className="border px-4 py-2">Jack Sparrow</td>
                                    <td className="border px-4 py-2">TA-107 New York</td>
                                    <td className="border px-4 py-2">02/05/2001</td>
                                    <td className="border px-4 py-2">+123 9988568</td>
                                    <td className="border px-4 py-2">kazifahim93@gmail.com</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="flex mt-8 mb-4 place-items-center  space-x-8 justify-center">
                            <h2 className="hover:cursor-pointer">Previous</h2>
                            <h2 className="bg-yellow-500 py-2 px-4 hover:cursor-pointer">1</h2>
                            <h2 className="hover:cursor-pointer">Next</h2>
                        </div>
                    </div>
                </div>

            </div>


        </div>
    );
}

export default Teachers;